import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import { Container } from '../../src/components/Grid';
import { Section } from '../../src/components/Layout';
import Text from '../../src/components/Typography/Text';
import theme from '../../src/theme';
import useMobile from '../../src/utils/useMobile';

const EventSlidesCarousel = dynamic(
  import('../../src/components/Carousel/EventSlidesCarousel'),
  {
    // eslint-disable-next-line react/display-name
    loading: () => <div />,
    ssr: false
  }
);

const More = ({ events, t }) => {
  const { isMobile } = useMobile();

  return (
    <Section>
      <Container>
        <Fade up>
          <Text
            as="h3"
            variant="heading2"
            color={theme.color.brand.primary}
            marginBottom="20px"
          >
            {t('common:events.related')}
          </Text>
          <EventSlidesCarousel slides={events} isMobile={isMobile} />
        </Fade>
      </Container>
    </Section>
  );
};

More.propTypes = {
  events: PropTypes.array,
  t: PropTypes.func
};

export default translate()(More);
